import type { Visualize3dComponent } from './visualize3d-component';
import type { ThreeJsMaterial } from '../models/three-js-material';
import { DoubleSide } from 'three';
import type { Visualize3dComponentCreator } from './visualize3d-component-creator';

export interface InteractiveComponent extends Visualize3dComponent {
  normal?: ThreeJsMaterial;
  hover?: ThreeJsMaterial;
  press?: ThreeJsMaterial;
  selected?: ThreeJsMaterial;
  isSelectable: boolean;
}

export const interactiveComponentCreator: Visualize3dComponentCreator<InteractiveComponent> = {
  createComponent: createInteractiveComponent,
};

/**
 * Creates new instance of the interactive component
 */
export function createInteractiveComponent(): InteractiveComponent {
  return {
    $type: 'MagiCADCore.Visualize3D.ThreeJS.DataTransfer.InteractiveDto, MagiCADCore.Visualize3D.ThreeJS',
    type: 'Interactive',
    isSelectable: true,
    normal: {
      parameters: JSON.stringify({
        transparent: false,
        side: DoubleSide,
      }),
      preserveColor: true,
      materialType: 'MeshLambertMaterial',
    },
    hover: {
      parameters: JSON.stringify({
        transparent: true,
        side: DoubleSide,
      }),
      preserveColor: false,
      materialType: 'MeshLambertMaterial',
    },
    press: {
      parameters: JSON.stringify({
        transparent: false,
        side: DoubleSide,
      }),
      preserveColor: false,
      materialType: 'MeshLambertMaterial',
    },
    selected: {
      parameters: JSON.stringify({
        transparent: false,
        side: DoubleSide,
      }),
      preserveColor: true,
      materialType: 'MeshLambertMaterial',
    },
  };
}
